import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getBackOfficeWallet = (person_id) => {
  return http.get(
    `${getBaseUrl()}/back_office_wallet/${person_id}`
  );
};